import { Context, createContext, PropsWithChildren, useContext } from "react";
import { observer } from "mobx-react-lite";
import { LifecycleStoreTask } from "@/store/Lifecycle/types";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { useStage } from "../Stage/Provider";

export const TaskContext = createContext<LifecycleStoreTask<StageTaskType>>(null);

export const TaskProvider = observer(<T extends StageTaskType>({ task, children }: PropsWithChildren<{ task: LifecycleStoreTask<T> }>) => {
    return (
        <TaskContext.Provider value={task}>
            {children}
        </TaskContext.Provider>
    );
});

export const useTask = <T extends StageTaskType>() => {
    const task = useContext<LifecycleStoreTask<T>>(TaskContext as Context<LifecycleStoreTask<T>>);
    const { isReadOnly } = useStage();
    return {
        ...task,
        isReadOnly: isReadOnly || task.isReadOnly
    };
};